@import '~@cewe-designsystem-stylecomponents/mixins/breakpoints';

:host {
  /* (Temp) Override early styles */
  max-width: unset !important;
  margin: unset !important;
}

/* cwc-timed-message-bar */

/* Hide the whole module if it's not active */
:host(:not([state='active'])) {
  display: none;
}

:host {
  display: flex;

  .wrapper {
    display: flex;
    box-sizing: border-box;
    align-content: center;
    align-items: center;
    width: 100%;
    max-width: 1368px;
    margin: 20px auto;
    padding: 8px;
    border-radius: 2px;
    background-color: #0576ad; /* BLUE-70 */
    color: #fff;
    text-align: center;
    text-decoration: none;

    @include breakpoint('sm') {
      padding: 8px 20px;
    }
  }

  .label {
    display: flex;
    flex-shrink: 0;
    font-weight: bold;

    .floating-image {
      display: block;
      width: 95px;
      height: 95px;
      margin: -37px 0;
      padding: 0 0 0 5px;

      @include breakpoint('sm') {
        padding: 0 0 0 10px;
      }
      @include breakpoint('md') {
        padding: 0 0 0 20px;
      }
    }
  }

  .text {
    display: flex;
    flex-grow: 1;
    justify-content: center;
    padding: 0 10px;
  }

  .more-info {
    text-wrap: nowrap;

    @include breakpoint('md', 'down') {
      display: none;
    }
  }
}

/* Decrease margins on PIP page */
:host(.pagetype-pip) {
  .wrapper {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}

/* Increase margins when an image attribute is set and not empty */
:host([image]:not([image=''])) {
  .wrapper {
    margin-top: 25px;
    margin-bottom: 25px;
  }
}

/* Apply an underline on messagebars containing a non-empty url */
:host([url]:not([url=''])) {
  .more-info {
    text-decoration: underline;
  }
}

/* Color schemes */
:host([color-scheme='blue']) {
  .wrapper {
    background-color: #0576ad; /* BLUE-70 */
    color: #fff;
  }
}

:host([color-scheme='red']) {
  .wrapper {
    background-color: #c30c15; /* RED-50 */
    color: #fff;
  }
}

:host([color-scheme='white']) {
  .wrapper {
    border: 1px solid #000;
    background-color: #fff;
    color: #000;
  }
}

:host([color-scheme='grey']) {
  .wrapper {
    background-color: #e4e4e4; /* LIGHTGREY-70 */
    color: #000;
  }
}

:host([color-scheme='green']) {
  .wrapper {
    background-color: #314d30; /* (copied from infobar) */
    color: #fff;
  }
}
